import './chunk-2452e3d3.js';
import './chunk-8cad1844.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import { F as Field } from './chunk-97f201e0.js';
export { F as BField } from './chunk-97f201e0.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Field);
  }
};
use(Plugin);

export default Plugin;



//////////////////
// WEBPACK FOOTER
// ./~/buefy/dist/esm/field.js
// module id = IHYB
// module chunks = 0 1